import { useMediaQuery } from './useMediaQuery'

/**
 * True au-delà du breakpoint Tailwind `lg` (1024px). Pilote l'UI de détail carte :
 * panneau latéral sur desktop, feuille basse sur téléphone. Défaut desktop quand
 * `matchMedia` est absent.
 */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 1024px)', true)
}
